'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';

const register = {
  init() {
    function Validate() {
      var password = document.getElementById("password_user").value;
      var confirmPassword = document.getElementById("password_confirmation").value;

      if (password != confirmPassword) {
        return false;
      }
      return true;
    }

    $('#password_confirmation').on('keyup', function () {
      if (!Validate()) {
        $(this).addClass('is-invalid');
      }
      else {
        $(this).removeClass('is-invalid');
      }
    });

    // const $form = $('#form-confirm-code');
    // const url = $form.attr('action');

    // $form.on('submit', function (e) {
    //   e.preventDefault();
    //   const captcha = grecaptcha.getResponse();
    //   const data = $($form).serializeArray();

    //   if (captcha.length == 0) {
    //     Swal.fire('Você deve marcar o captcha para continuar!', '', 'error');
    //     return false;
    //   }

    //   $.ajax({
    //     type: 'POST',
    //     url,
    //     data,
    //     dataType: 'json',
    //     success: function (data) {
    //       Swal.fire(data.title, data.message, data.type).then(() => {
    //         if (data.type == 'success') {
    //           window.location.href = data.redirect;
    //         }
    //       });
    //     },
    //     error: function (xhr, status, error) {
    //       console.error('AJAX request failed:', status, error);
    //     },
    //     complete: function () {
    //       grecaptcha.reset();
    //     }
    //   });
    // });
  }
}

export default register;